import React from 'react';
import { getChatAIURL } from '../../config.js';

const ChatAI = () => {
      const chatAIURL = getChatAIURL();

    return (    
        <iframe 
            title="Chat AI"
            src={chatAIURL}
            style={{width: '100%', height: 'calc(100vh - 50px)'}}
        />
    )
}

export default ChatAI;
